import { motion } from "framer-motion";
import ArtworkCard from "@/components/site/ArtworkCard";

const aspects = ["aspect-[4/5]", "aspect-[5/6]", "aspect-[4/5]", "aspect-[3/4]"];

export default function Collection({ artworks = [] }) {
  const left = artworks.filter((_, i) => i % 2 === 0);
  const right = artworks.filter((_, i) => i % 2 === 1);

  return (
    <section
      id="collection"
      className="relative py-24 md:py-36 bg-paper"
      data-testid="collection-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-16 md:mb-24">
          <div className="md:col-span-8">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-body text-[11px] tracking-[0.35em] uppercase text-ochre mb-5"
            >
              The Collection &mdash; Original Works
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1] text-ink tracking-tight"
            >
              Available <span className="italic text-ochre">originals</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="md:col-span-4 font-body text-base text-ink-soft leading-relaxed"
          >
            Each canvas is one of one &mdash; hand-painted, signed, and ready to be lived
            with. Select a work to enquire; the studio arranges viewing, framing and
            worldwide shipping.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-x-8 lg:gap-x-16">
          <div className="flex flex-col gap-16 md:gap-24">
            {left.map((art, i) => (
              <ArtworkCard key={art.slug} art={art} index={i * 2} aspect={aspects[i % aspects.length]} />
            ))}
          </div>
          <div className="flex flex-col gap-16 md:gap-24 md:mt-32">
            {right.map((art, i) => (
              <ArtworkCard key={art.slug} art={art} index={i * 2 + 1} aspect={aspects[(i + 1) % aspects.length]} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
